import React,{useState,useEffect} from 'react'
import { useNavigate,useLocation } from "react-router-dom"; 
import { StarIcon } from '@heroicons/react/solid'
import { RadioGroup } from '@headlessui/react'
import Loader from '@components/Loader';
import moment from "moment"
import Web3 from "web3";
import { useWeb3Auth } from "@services/web3auth";
import { useWeb3AuthWallet } from "@services/web3authWallet";
import Swal from 'sweetalert2'
//load token
import {ABI, ADDRESS} from '@contracts/groupBy'
import {ABI as ABITOKEN } from '@contracts/token'
import axios from 'axios'
import { PlusIcon,MinusIcon } from '@heroicons/react/outline'

// usdt token
const token_address = '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd';

const product = {
    name: 'play5',
    price: '192',
    href: '#',
    breadcrumbs: [
      { id: 1, name: 'market', href: '/dapp' },
    ],
    images: [
      {
        src: 'https://mercular.s3.ap-southeast-1.amazonaws.com/images/products/2021/11/Product/gopro-hero-10-black.jpg',
        alt: 'Two each of gray, white, and black shirts laying flat.',
      },
    ],
    colors: [
      { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
      { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
      { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
    ],
    sizes: [
      { name: '1', inStock: true },
      { name: '2', inStock: true },
      { name: '3', inStock: true },
      { name: '4', inStock: true },
      { name: '5', inStock: true },
  
    ],
    description:
      'สำหรับกล้อง Action Camera แล้ว พูดได้เต็มปากว่า ไม่มีเจ้าไหนดังและน่าจดจำไปมากกว่า GoPro อีกแล้ว และในตอนนี้ GoPro ก็ได้เปิดตัวกล้องเรือธงลำดับที่สิบของแบรนด์อย่างกล้อง GoPro HERO10 Black มาสร้างแรงกระเพื่อมใหญ่ต่อวงการกล้องขาลุยอีกครั้ง และการมาในวาระครบรอบสิบรุ่นนี้ ไม่ได้มีแค่อัพเกรดสเปคเล็กน้อยๆ เท่านั้น แต่ยังยกเครื่องใหม่หมดตั้งแต่ชิปเซ็ตของกล้อง ระบบภายใน ไปจนถึงกล่องบรรณจุภัณฑ์เลยด้วย ซึ่งสเกลการอัพเกรดครั้งนี้จะเปลี่ยนกล้องไปขนาดไหน ลองมาอ่านต่อดูได้เลย',
    highlights: [
       ' กล้องแอคชันแคมจาก GoPro',
        'ถ่ายวิดีโอด้วยความละเอียดสูงถึง 5.3K 60Fps',
       ' ถ่าย Slow Motion ได้ถึง 4K 120FPS',
        'รองรับไฟล์ RAW',
       ' กันน้ำลึกได้ถึง 10 เมตร',
        'โอนถ่ายและตัดต่อวีดีโอด้วยแอพพลิเคชั่น GoPro Quik',
        'ระบบ GPS ในตัว',
      '  ระบบกันภาพสั่นไหว HyperSmooth 4.0',
        'TimeWarp 3.0',
      '  โหมด Webcam และ Live Stream ความละเอียด 1080p',
       ' ระบบสั่งการด้วยเสียง',
        'Super Photo ปรับการตั้งค่าให้เหมาะกับสภาพแวดล้อมอัตโนมัติ',
        'HindSight บันทึกวีดีโอล่วงหน้าก่อนกดชัตเตอร์สูงสุด 30 วินาที',
        'Schedule Capture ตั้งเวลาถ่ายและปิดอัตโนมัติ',
       ' เมาท์ Folding Fingers ติดกล้อง',
      
        ],
    details:
      'กล้อง Action Camera จากแบรนด์ดังอย่าง GoPro ที่คราวนี้มาในชื่อ GoPro HERO10 Black โดยยังคงมีจุดเด่นของความเป็นกล้องแอคชันแคมเหมือนเดิม ตัวกล้องมีขนาด 7 x 3.2 x 4.7 เซนติเมตร น้ำหนัก 153 กรัม ตัวบอดี้ยังคงแข็งแรง ทนทาน กันน้ำลึกได้ถึง 10 เมตร และมีเมาท์แบบ Folding Fingers ติดมากับกล้องด้วย ส่วนระบบภายในก็ถูกอัพเกรดด้วยชิปเซ็ต GP2 ที่พัฒนามาใหม่ล่าสุด สามารถถ่ายวิดีโอที่ความละเอียดสูงสุด 5.3K 60 เฟรมภาพต่อวินาที, ถ่ายภาพนิ่งที่ 23 ล้านพิกเซล, ปรับปรุงประสิทธิภาพการถ่ายในที่แสงน้อยให้ดีขึ้นกว่ารุ่นก่อนๆ และระบบกันภาพสั่นไหวของวิดีโอ HyperSmooth 4.0 ที่ยกระดับจนได้ภาพที่นุ่มนวลอย่างน่าเหลือเชื่อ ส่วนฟีเจอร์อื่นๆ อย่างเช่น TimeWarp 3.0 ที่ช่วยให้เราถ่ายวิดีโอแบบเร่ง - ย่นเวลาได้อย่างง่ายดาย โหมด Slow Motion ที่สามารถถ่ายด้วยความละเอียด 4K 120fps ได้แล้ว โหมด HindSight ที่จะบันทึกวีดีโอล่วงหน้าก่อนกดชัตเตอร์ได้สูงสุด 30 วินาที Schedule Capture สำหรับการตั้งเวลาถ่ายและปิดอัตโนมัติ และโหมด Webcam สำหรับสายสตรีมเมอร์และ Vlogger ที่อยากไลฟ์สด ถือว่าการมาของ GoPro HERO10 Black นั้นตอบโจทย์ทุกอย่างที่ผู้ใช้งานต้องการจริงๆ ',
  }


  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
  }

  
function Detail() {

    const [selectedColor, setSelectedColor] = useState(product.colors[0])
    const [selectedSize, setSelectedSize] = useState<number>(0)
    const [loading,setLoading] = useState(false)

    const { provider, privateKey } = useWeb3Auth();
    const {web3Auth,WalletConnectProvider,connected} = useWeb3AuthWallet();

    const [disabled,setDisabled] = useState(false);
    const [balance,setBlance] = useState<string>('0');
    const [TokenBlance,setTokenBlance] = useState<string>('0');
    
    const [Account,setAccount] = useState('');
    const [groupBuy,setGroupBuy] = useState<any>(undefined);
    const [contractToken,setContractToken] = useState<any>(undefined);
    const [web3,setWeb3] = useState<any>(undefined);

    const [profile,setProfile] = useState<any>({})
  
    const navigate = useNavigate();

    const abi:any = ABI
    const token_abi:any = ABITOKEN

    const value:any = useLocation();
    const {products,date_expire}  = value.state;
    


  useEffect(() => {
      
    const getAccout = async ()=>{
      try {

        const web3 = new Web3(provider);
        const accounts = web3.eth.accounts.privateKeyToAccount(privateKey);
        web3.eth.accounts.wallet.add(accounts);

        const amount =  await web3.eth.getBalance(accounts.address);
        const balance:string = await Web3.utils.fromWei(amount);
  

        const groupbuy = new web3.eth.Contract(abi, ADDRESS);
        const token = new web3.eth.Contract(token_abi, token_address);
        const token_balance = await token.methods.balanceOf(accounts.address).call();

        setAccount(accounts.address)
        setBlance(balance)
        setTokenBlance(token_balance)
        setGroupBuy(groupbuy)
        setContractToken(token)
        setWeb3(web3)
      } catch (error) {
        console.log(error);
        
      }
   
    }
    if (privateKey)
      getAccout();
    return () => {}
  }, [privateKey]);

  useEffect(() => {
    const getAccout = async ()=>{
      try {
        const providers = WalletConnectProvider ?? web3Auth.provider 
        const web3 = new Web3(providers);
        const accounts = await web3.eth.getAccounts();
        const groupbuy = new web3.eth.Contract(abi, ADDRESS);
        const token = new web3.eth.Contract(token_abi, token_address);
        const amount =  await web3.eth.getBalance(accounts[0]);
        const balance:string = await Web3.utils.fromWei(amount);

        const token_balance = await token.methods.balanceOf(accounts[0]).call();
  
        setTokenBlance(token_balance)
        setGroupBuy(groupbuy)
        setContractToken(token)
        setAccount(accounts[0])
        setWeb3(web3)
        setBlance(balance)
      } catch (error) {
        console.log(error);
        
      }
   
    }
    if (connected)
      getAccout();
    return () => {}
  }, [connected]);

  //check register address
  useEffect(() => {
        const regisContect = async()=>{
            let  successful = true;
            try {
                await axios.post(`https://cnx-groupby-demo.leafbot.io/api/demo/account/${Account}`, { action: 'info'}).then(async (res)=>{
                    const data = res.data;
                   
                    if (data.data){
                        const val = data.data;
                        const input =  { 
                            WalletAddress: val.walletAddress, 
                            Address: val.shippingAddress,
                            FirstName:val.firstName,
                            LastName:val.lastName,
                            Tel:val.tel,
                            Email:val.email,
                            ContactName:val.contractName,
                            Zipcode:val.zipCode,
                            ContactTel:val.contactTel,
                            status:val.emailStatus
                        
                        }
                        setProfile(input)
                        if (input.status === 'PENDING'){

                            await Swal.fire({
                                title: 'Message',
                                text: 'ยังไม่ได้ยืนยันอีเมล',
                                icon: 'warning',
                                confirmButtonColor: '#3085d6',
                                // showCancelButton: true,
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'ยืนยัน',
                                // cancelButtonText: 'ยกเลิก'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    navigate(`/profile/${Account}`)
                                }
                            })

                        }else{
                            if(input.WalletAddress !== ''){
                                successful = true;
                            }else{
                                successful = false;
                            }
                        }
                       
                       
                        // setVerified(val.emailStatus)
                        // setDataUser(input);
                    }
                })
               
            } catch (error) {
                successful = false;
            }

            if (!successful){
                await Swal.fire({
                    title: 'Message',
                    text: 'ยังไม่ได้ระบุที่อยู่จัดส่ง',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    // showCancelButton: true,
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'เพิ่มที่อยู่จัดส่ง',
                    // cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/profile/${Account}`)
                    }
                })
            }
          
        }

    if (Account) regisContect()
  
  }, [Account])
  



    const onClickCancal = async () => {

        await Swal.fire({
            title: 'Message',
            text: `ยกเลิกรายการทั้งหมด`,
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
        }).then(async (result) => {
               // // setOpen(false);
               if (result.isConfirmed) {
                    setLoading(true)
                    try {
                        await groupBuy.methods.cancalOrder().send({
                            from: Account,
                            // gas: 210000
                        });
                        setLoading(false)
                        // window.location.reload();
                        await Swal.fire({
                            title: 'Transfer success',
                            text: 'Cancal orders finish',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'ok'
                        })
                        // navigate('/dapp')
                        await updateRequest(Account,ADDRESS)
                        
                    } catch (error:any) {
                        setLoading(false)
                        await Swal.fire({
                            title: 'Transfer fail',
                            text: error.message,
                            icon: 'warning',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'ok'
                        })
                        
                    }
               }
        })

    };

    const requestOrder = async ()=>{

        if(!selectedSize){
            await Swal.fire({
                title: 'Errors',
                text: 'ระบุจำนวนที่ต้องการ',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ok'
            })
            return false;
        } 

        await Swal.fire({
            title: 'Message',
            text: `ยืนยันคำสั่งซื้อจำนวน ${selectedSize} ชิ้น`,
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            reverseButtons:true,
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ยืนยัน',
        }).then(async (result) => {
               // // setOpen(false);
               if (result.isConfirmed) {
                    setLoading(true)
                    const amount = selectedSize;
                    var val = (amount * products.price);
                    const cal = Web3.utils.toWei(val.toString(), 'ether');

                    try {
                        await contractToken.methods.approve(ADDRESS,cal).send({
                        from: Account,
                        // gasLimit: 80000
                        });
                    } catch (error:any) {
                        setLoading(false)
                        await Swal.fire({
                            title: 'Transfer fail',
                            text: error.message,
                            icon: 'warning',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'ok'
                        })
                    }
                
                    try {
                    const res = await groupBuy.methods.request_order(amount).send({
                        from: Account,
                        // gasPrice: 100000000,
                        // gasLimit: 80000,
                        // gas: 1000000
                    });

                    const data = {
                        res: res,
                        profile:profile,
                        amount:selectedSize
                    }
                    
                    
                    //save log
                    await saveRequest(products,data);

                  
                    } catch (error:any) {
                        setLoading(false)

                        await Swal.fire({
                            title: 'Transfer fail',
                            text: error.message,
                            icon: 'warning',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'ok'
                        })
                    }
               }

         })

    
    }

    const decValue =async () => {
        let val = selectedSize - 1;
        if (val < 0) val = 0
        setSelectedSize(val)
    }
    const incValue =async () => {
        let val = selectedSize  + 1;
        setSelectedSize(val)
    }

    const changeAmount = (event: { target: { value: any; }; })=>{
        if (event.target.value){
            if (isNaN(event.target.value)) {
                return;
              }
              let onlyNums = event.target.value.replace(/[^0-9]/g, "");
              if (onlyNums > products.max) onlyNums = products.max
            setSelectedSize(parseInt(onlyNums))
        }

    }
 
    const saveRequest = async (products:any,data:any) =>{
        const input = {
            amount: data.amount,
            price: products.price,
            walletAddress: Account,
            contractAddress: ADDRESS,
            transactionHash: data.res.transactionHash,
            productName: products.name,
            // Status:'success',
            props:{},
            runno: moment().format('ymmd')+(Math.floor(Math.random()*90000) + 10000)
        }

        setLoading(false)

        await axios.post(`https://cnx-groupby-demo.leafbot.io/api/demo/order/${Account}/create`,input).then(async (res:any)=>{
            navigate('/dapp/confirmed', { state: {data}});
           
        })
        .catch(async (err:any)=>{
            const res = err.response.data
            setLoading(false)

            await Swal.fire({
                title: 'Transfer fail',
                text: res.message,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ok'
            })
        })
    
  
        
    }

    const updateRequest = async (accounts:any,address:any) =>{
        try {
            await axios.get(`https://api.airtable.com/v0/appUuOWAHjGFOgM4M/requests?filterByFormula=SEARCH("${Account}",WalletAddress)`,{
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': 'application/json',
                'Authorization': `Bearer keyXS39pJOlAd3YW3`

            }}).then((res)=>{
                const data = res.data.records;
                data.map((item:any) => {
                    const input ={
                        Status:'cancel'
                    }
                    const form = {
                        "records": [
                            {
                                "id":item.id,
                                "fields": input
                            }
                        ]
                    }
                    try {
                        axios.patch(`https://api.airtable.com/v0/appUuOWAHjGFOgM4M/requests`,form,{
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8',
                            'accept': 'application/json',
                            'Authorization': `Bearer keyXS39pJOlAd3YW3`
            
                        }}).then(async (res)=>{
                            navigate('/dapp')
                        })
                    } catch (error) {
                        console.log(error);
                    }
                })
               
                
            })
        } catch (error) {
            console.log(error);
            
        }
        // const input = {
       
           
        // }
      
        // const forms ={
        //     "records": [
        //         {
        //         "fields": input
        //         }
        //     ]
        // }
        // try {
        //     await axios.post(`https://api.airtable.com/v0/appUuOWAHjGFOgM4M/requests`,forms,{
        //     headers: {
        //         'Content-Type': 'application/json;charset=UTF-8',
        //         'accept': 'application/json',
        //         'Authorization': `Bearer keyXS39pJOlAd3YW3`

        //     }}).then(async (res)=>{
        //         navigate('/dapp/confirmed', { state: {data}});
        //     })
        // } catch (error) {
        //     console.log(error);
        // }
  
        
    }

    if (loading){
       return (<Loader/>)
    }
    
    return (
        <main>
            <div className="max-w-7xl mx-auto py-4 sm:px-6 lg:px-8 sm:px-4">
                <div className="bg-white">
                    <div className="pt-6">
                        <nav aria-label="Breadcrumb">
                            <ol role="list" className="mx-auto flex items-center space-x-2 sm:px-6 lg:max-w-7xl lg:px-8">
                                {product.breadcrumbs.map((breadcrumb) => (
                                <li key={breadcrumb.id}>
                                    <div className="flex items-center">
                                    <a href={breadcrumb.href} className="mr-2 text-sm font-medium text-gray-900">
                                        {breadcrumb.name}
                                    </a>
                                    <svg
                                        width={16}
                                        height={20}
                                        viewBox="0 0 16 20"
                                        fill="currentColor"
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        className="w-4 h-5 text-gray-300"
                                    >
                                        <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                                    </svg>
                                    </div>
                                </li>
                                ))}
                                <li className="text-sm">
                                <a href={product.href} aria-current="page" className="font-medium text-gray-500 hover:text-gray-600">
                                    {products.name}
                                </a>
                                </li>
                            </ol>
                        </nav>
                        {/* Product info */}
                        <div className="pt-10 pb-16 px-4 sm:px-6 lg:max-w-7xl lg:pt-16 lg:pb-24 lg:px-8 lg:grid lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8">
                            <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8 ">
                                    {/* Image gallery */}
                                    <section className="hero container max-w-screen-lg mx-auto flex justify-center  w-3/4">
                                        <img
                                            src={product.images[0].src}
                                            alt={product.images[0].alt}
                                            // className="items-center justify-center"
                                            style={{width:'100%'}}
                                            />
                                    </section>
                                
                            </div>

                            {/* Options */}
                            <div className="mt-10 lg:mt-0 lg:row-span-3">
                                {/* <h2 className="sr-only">Product information</h2> */}
                                ชื่อสินค้า
                                <div className='grid grid-cols-1 mb-2'>
                                    <h1 className="text-md font-extrabold tracking-tight text-gray-900 sm:text-xl"> {products.name}</h1>
                                    <p className="text-gray-900 font-bold text-lg"> ราคา 5,000 บาท ({products.price} USDT)  </p>
                                </div>
                                <div className='grid grid-cols-2  mb-2'>
                                    <p className="text-md  tracking-tight text-gray-900 sm:text-md">รหัสสินค้า {products.id}</p>
                                </div>
                            
                                <div className="mt-4 lg:mt-0 lg:row-span-3 grid grid-cols-1 text-right">
                                    <p>จำนวนสั่งจองขั้นต่ำที่ต้องการ {products.min} ชิ้น</p>
                                  
                                </div>
                                <div className="mt-4 lg:mt-0 lg:row-span-3 grid grid-cols-1 text-right">
                 
                                    <p>สั่งจองไปแล้ว {products.qty_current} ชิ้น</p>
                                </div>
                                
                              
                                <hr />
                                <div className='grid lg:row-span-3 text-right  mt-2'>
                                    <p className="text-md text-gray-900"> สิ้นสุดแคมเปญ { moment(parseInt(products.expired+'000')).format("DD/MM/YYYY") } </p>
                                </div>

                                <div className='grid lg:row-span-3  text-right'>
                                    <p className="text-md text-gray-900"> สถานะแคมเปญ <strong className=' text-green-500'>เปิดให้สั่งจอง</strong> </p>
                                </div>
                            
                                <form className="">

                                {/* Sizes */}
                                <div className="mt-5">
                                    <div className="flex items-center justify-between">
                                        <h3 className="text-sm font-bold text-gray-900">ระบุจำนวนที่ต้องการ</h3>
                                    </div>
                                    <div className='flex items-center justify-center'>
                                    <div className="custom-number-input h-12 w-32">
                                        <div className="flex flex-row h-12 w-full rounded-lg relative bg-transparent mt-1 ">
                                            <button onClick={decValue} type='button' data-action="decrement" className=" bg-red-300 text-red-600 hover:text-red-700 hover:bg-red-400 h-full w-20 rounded-l cursor-pointer outline-none">
                                                <MinusIcon className='m-auto h-6 w-6'/>
                                            </button>
                                            <input  onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} type="text" className="outline-none focus:outline-none text-center w-full bg-gray-200 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none" value={selectedSize} onChange={changeAmount} ></input>
                                            <button onClick={incValue} type='button' data-action="increment" className="bg-green-300 text-green-600 hover:text-green-700 hover:bg-green-400 h-full w-20 rounded-r cursor-pointer">
                                                <PlusIcon className='m-auto h-6 w-6'/>
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    

                                    {/* <RadioGroup value={selectedSize} onChange={setSelectedSize} className="mt-4">
                                    <RadioGroup.Label className="sr-only">Choose a size</RadioGroup.Label>
                                    <div className="grid grid-cols-4 gap-4 sm:grid-cols-8 lg:grid-cols-6">
                                        {product.sizes.map((size) => (
                                        <RadioGroup.Option
                                            key={size.name}
                                            value={size}
                                            disabled={!size.inStock}
                                            className={({ active }) =>
                                            classNames(
                                                size.inStock
                                                ? 'bg-white shadow-sm text-gray-900 cursor-pointer'
                                                : 'bg-gray-50 text-gray-200 cursor-not-allowed',
                                                active ? 'ring-2 ring-indigo-500' : '',
                                                'group relative border rounded-md py-3 px-4 flex items-center justify-center text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 '
                                            )
                                            }
                                        >
                                            {({ active, checked }) => (
                                            <>
                                                <RadioGroup.Label as="p">{size.name}</RadioGroup.Label>
                                                {size.inStock ? (
                                                <div
                                                    className={classNames(
                                                    active ? 'border' : 'border-2',
                                                    checked ? 'border-indigo-500' : 'border-transparent',
                                                    'absolute -inset-px rounded-md pointer-events-none'
                                                    )}
                                                    aria-hidden="true"
                                                />
                                                ) : (
                                                <div
                                                    aria-hidden="true"
                                                    className="absolute -inset-px rounded-md border-2 border-gray-200 pointer-events-none"
                                                >
                                                    <svg
                                                    className="absolute inset-0 w-full h-full text-gray-200 stroke-2"
                                                    viewBox="0 0 100 100"
                                                    preserveAspectRatio="none"
                                                    stroke="currentColor"
                                                    >
                                                    <line x1={0} y1={100} x2={100} y2={0} vectorEffect="non-scaling-stroke" />
                                                    </svg>
                                                </div>
                                                )}
                                            </>
                                            )}
                                        </RadioGroup.Option>
                                        ))}
                                    </div>
                                    </RadioGroup> */}
                                </div>
                                <div className="mt-5 p-2 relative">
                                    {(balance > '0' && TokenBlance > '0') ? 
                                    <div>
                                        <div className="flex items-center justify-between">
                                        <h3 className="text-sm font-bold text-gray-900">ที่อยู่จัดส่ง</h3>
                                    </div>
                                    {profile.ContactName ? 
                                        <div>
                                            <div className='px-2 py-1'>
                                                <p className='text-sm'>{profile.ContactName} {profile.Address} {profile.Zipcode}</p>
                                                <p className='text-sm'>เบอร์ติดต่อ( {profile.ContactTel} )</p>
                                            </div>
                                            <div className="absolute top-0 right-0 p-1">
                                                <p onClick={()=>navigate(`/profile/${Account}`)} className='text-sm hover:text-blue-400 cursor-pointer text-blue-300'>แก้ไขที่อยู่</p>
                                            </div>
                                        </div>
                                        :
                                        <div className='flex  justify-center'>
                                            <p onClick={()=>navigate(`/profile/${Account}`)} className='text-md hover:text-blue-400 cursor-pointer text-blue-300'>เพิ่มที่อยู่จัดส่ง</p>
                                        </div>
                                    }
                                        <button
                                            onClick={()=>requestOrder()}
                                            disabled={date_expire ? true:false}
                                            type="button"
                                            className={`mt-10 w-full ${date_expire ? 'bg-red-300' :'bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 '} border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 `}
                                        >
                                            สั่งจอง
                                        </button>
                                     {/* {date_expire ?
                                            <button
                                                disabled={true}
                                                type="button"
                                                className="mt-10 w-full bg-indigo-200 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-200"
                                            >
                                                สิ้นสุดแคมเปญ
                                            </button>

                                        :
                                        <button
                                            onClick={()=>requestOrder()}
                                            disabled={balance > '0' ? false:true}
                                            type="button"
                                            className="mt-10 w-full bg-indigo-600 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            สั่งจอง
                                        </button>

                                        } */}
                                    </div>
                                    :
                                        <div className='flex justify-center'>
                                            <p className='text-red-500 text-sm'>ไม่พบเหรียญที่ใช้งานได้</p>
                                        </div>
                                    }
                                  
                                    {/* <button
                                        disabled={products.user_order <= 0 ?true:false }
                                        onClick={()=>onClickCancal()}
                                        type="button"
                                        className={`${products.user_order > 0  ? 'bg-red-500 hover:bg-red-700' :'bg-red-200' } w-full mt-2 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                                    >
                                        ยกเลิกการจอง
                                    </button> */}
                                </div>
                               
                                
                              
                                </form>
                            </div>

                            <div className="py-10 lg:pt-6 lg:pb-16 lg:col-start-1 lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
                                {/* Description and details */}
                                <div>
                                    <h3 className="sr-only">รายละเอียด</h3>

                                    <div className="space-y-6">
                                        {/* <p>สรุป ลำโพง Sony SRS-XB01 Bluetooth Speaker เหมาะกับใคร?</p> */}
                                        <p className="text-base text-gray-900">{product.description}</p>
                                    </div>
                                    
                                </div>

                                <div className="mt-10">
                                <h3 className="text-sm font-medium text-gray-900">Key Highlight</h3>

                                <div className="mt-4">
                                    
                                    <ul role="list" className="pl-4 list-disc text-sm space-y-2">
                                    {product.highlights.map((highlight) => (
                                        <li key={highlight} className="text-gray-400">
                                        <span className="text-gray-600">{highlight}</span>
                                        </li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                                <br />
                                <div className="space-y-6">
                                    <h3 className="text-sm font-medium text-gray-900">กล้อง GoPro Hero 10 Black เหมาะกับใคร</h3>
                                    <p className="text-base text-gray-900">{product.description}</p>
                                </div>

                                <div className="mt-10">


                                {/* <div className="mt-4 space-y-6">
                                <h3 className="text-sm font-medium text-gray-900">รีวิวเสียง</h3>
                                <p className="text-base text-gray-900">{product.details}</p>
                                </div> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Detail